module.exports = __webpack_public_path__ + "static/media/separador_breadcrumb.43a0ca5c.svg";